/** Rows per page for the client-side pagination of both Track tables. */
export const TRACK_PAGE_SIZE = 50;

/** Server `pageSize` for one Track fetch. */
export const TRACK_FETCH_BATCH_SIZE = 100;

/** Batches fetched without user action: the first one, then the auto-chain. */
export const TRACK_INITIAL_BATCHES = 5;

/** Pagination labels shared by both Track tables. */
export const TRACK_PAGINATION_ARIA_LABELS = {
  nextPageLabel: 'Next page',
  previousPageLabel: 'Previous page',
  pageLabel: (pageNumber: number) => `Page ${pageNumber}`,
};

/**
 * UI string constants for the Track Translations feature.
 * Centralizes all user-facing text for maintainability and future i18n.
 */

export const TRACK_STRINGS = {
  PAGE_TITLE: 'Track Translations',
  PAGE_DESCRIPTION:
    'Monitor the status of all your current and historical translation jobs.',

  ERROR_ACTIVE_HEADER: 'Error loading active jobs',
  ERROR_HISTORICAL_HEADER: 'Error loading historical jobs',
  ERROR_BODY:
    'Something went wrong while fetching translation data. Please try again later or contact the LangHub team if the problem persists.',

  ACTIVE_JOBS_HEADER: 'Jobs Currently Under Translation',
  /** Info tooltip to the right of the heading and its result count. */
  ACTIVE_JOBS_INFO: 'This table only has the groups currently being translated',
  ACTIVE_JOBS_LOADING: 'Loading active jobs',
  ACTIVE_JOBS_EMPTY_TITLE: 'No active jobs',
  ACTIVE_JOBS_EMPTY_BODY:
    'No in-progress translation jobs found for the selected filters.',

  HISTORICAL_JOBS_HEADER: 'Historical Jobs',
  /** Info tooltip to the right of the heading and its result count. */
  HISTORICAL_JOBS_INFO:
    'This table has completed, failed, and cancelled job details',
  HISTORICAL_JOBS_LOADING: 'Loading historical jobs',
  HISTORICAL_JOBS_EMPTY_TITLE: 'No historical jobs',
  HISTORICAL_JOBS_EMPTY_BODY:
    'No completed translation jobs found for the selected filters.',

  LOAD_MORE: 'Load more',

  SORT_WINDOW_NOTICE_DISMISS: 'Dismiss sorting scope notice',

  /** Shown only while more jobs remain unloaded AND the user has sorted. */
  SORT_WINDOW_NOTICE: (loadedCount: number) =>
    `Sorting the ${loadedCount} most recent jobs in this range. Load more to include older jobs, or narrow the date range or pick a string group.`,
} as const;
